import React, { Suspense } from 'react'
import Appbar from './Appbar'
import { Outlet } from "react-router-dom"
import SessionRemainingTimer from './SessionRemainingTimer'

const Layout = () => {
    return (
        <>
            <Appbar />
            <br />
            <SessionRemainingTimer />
			<Suspense fallback={'loading...'}>
				<Outlet />
			</Suspense>
        </>
    )
}

export default Layout